'use client';

import { useMutation } from '@tanstack/react-query';
import { useRouter } from 'next/navigation';
import { toast } from 'sonner';

import type { AppLocale } from '@/i18n/locales';

/** Sets the `locale` cookie via `/api/locale` (e.g. login page before a workspace exists). */
export function usePersistAppLocale() {
  const router = useRouter();

  return useMutation({
    mutationFn: async (locale: AppLocale) => {
      const res = await fetch('/api/locale', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ locale }),
      });
      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(
          typeof body?.error === 'string' ? body.error : 'Failed to set locale',
        );
      }
    },
    onSuccess: () => router.refresh(),
    onError: (error: unknown) => {
      const message = error instanceof Error ? error.message : 'Please try again.';
      toast.error('Failed to set language', {
        description: message,
      });
    },
  });
}
